// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__21Wpv","bigColWidth":"Table_bigColWidth__wyu1z","biggerColWidth":"Table_biggerColWidth__eaM8F","row":"Table_row__2GjeI","col":"Table_col__au1rR"};